export type HCaptchaWidgetId = string | number

export type HCaptchaApi = {
  render: (
    element: HTMLElement,
    options: Record<string, unknown>
  ) => HCaptchaWidgetId
  reset: (id?: HCaptchaWidgetId) => void
  remove?: (id: HCaptchaWidgetId) => void
}

declare global {
  interface Window {
    hcaptcha?: HCaptchaApi
    __vetpetsHCaptchaReady?: () => void
  }
}

let scriptPromise: Promise<HCaptchaApi> | null = null

export function loadHCaptchaRuntime(): Promise<HCaptchaApi> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("hCaptcha yalnız tarayıcıda kullanılabilir."))
  }
  if (window.hcaptcha) return Promise.resolve(window.hcaptcha)
  if (scriptPromise) return scriptPromise

  scriptPromise = new Promise<HCaptchaApi>((resolve, reject) => {
    const rejectRuntime = (error: Error) => {
      scriptPromise = null
      reject(error)
    }

    window.__vetpetsHCaptchaReady = () => {
      if (window.hcaptcha) {
        resolve(window.hcaptcha)
        return
      }
      rejectRuntime(new Error("hCaptcha API hazır değil."))
    }

    const existing = document.querySelector<HTMLScriptElement>(
      'script[data-vetpets-hcaptcha="true"]'
    )
    if (existing) {
      existing.addEventListener(
        "error",
        () => rejectRuntime(new Error("hCaptcha script yüklenemedi.")),
        { once: true }
      )
      return
    }

    const script = document.createElement("script")
    script.src =
      "https://js.hcaptcha.com/1/api.js?onload=__vetpetsHCaptchaReady&render=explicit&hl=tr"
    script.async = true
    script.defer = true
    script.dataset.vetpetsHcaptcha = "true"
    script.onerror = () => {
      script.remove()
      rejectRuntime(new Error("hCaptcha script yüklenemedi."))
    }
    document.head.appendChild(script)
  })

  return scriptPromise
}
